export { default as anatomyDigestivePNG } from '~/assets/images/anatomy/anatomy-digestive-light.png'
export { default as anatomyDigestiveWEBP } from '~/assets/images/anatomy/anatomy-digestive-light.webp'

export const ANIMATION_DURATION = 3000
export const INTRO_ACCENT_COLOR = '#8c67f6'
